module.exports = __webpack_public_path__ + "img/u921.109e7860.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/price/u921.png
// module id = 587
// module chunks = 137